import React, { Component } from 'react';
import { select, scaleBand, scaleTime, axisTop, axisLeft, timeParse, timeMinute, timeFormat, min, max, mouse } from 'd3';

import './Agenda.css';

class Agenda extends Component {

  state = {
    margin: {top: 60, left: 60, right: 0, bottom: 10 },
    tooltip: { display: 'none', x: 0, y: 0 }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
  }

  componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.data) {
      const profession = this.props.data[0].beroepsgroep;
      if (profession !== this.state.profession) {
          this.createAgenda();
          this.updateDimensions();
          this.setState({ profession });
      }
    }
  }
  updateDimensions = () => {
    if (!this.container) return;
    const width = this.container.clientWidth,
          height = this.props.height;
    if (this.state.width !== width || this.state.height !== height){
      this.setState({ width, height })
    }
  }

  createAgenda = () => {
    const { data, showAdmin, colors, showProfession } = this.props;
    const { width, height, margin } = this.state;
    const widthChart = width - margin.left;
    const heightChart = height - margin.top - margin.bottom;
    const dagen = ['maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag', 'zondag'];

    const parseTime = timeParse("%H:%M:%S");
    const formatTime24 = (time) => {
      const formattedTime = timeFormat('%H:%M uur')(time);
      return formattedTime === '00:00 uur' ? '24:00 uur' : formattedTime;
    }

    const earliest = min(data, d => d.start);
    const latest = max(data, d => d.eind);
    const start = timeMinute.offset(parseTime(earliest), -30);
    const end = timeMinute.offset(parseTime(latest), +30);

    const xScale = scaleBand().range([0, widthChart]).domain(dagen).paddingInner(.05);
    const yScale = scaleTime().range([heightChart, 0]).domain([end, start]);

    const xAxis = axisTop(xScale).ticks(0).tickValues(dagen).tickSize(0).tickPadding(12);
    const yAxis = axisLeft(yScale).ticks().tickFormat(formatTime24).tickSize(-widthChart);

    const agenda = select(this.container).select('.groep');

    agenda.select('.x.as').call(xAxis);
    agenda.select('.y.as').call(yAxis);


    const weekdagen = agenda.select('.dagen').selectAll('.dag').data(dagen, d => d);

    weekdagen.exit().remove();

    weekdagen
      .enter()
        .append('rect').attr('class', d => 'dag ' + d)
      .merge(weekdagen)
        .attr('fill', d => colors['dag'])
        .attr('stroke', 'none')
        .attr('height', heightChart)
        .attr('width', xScale.bandwidth())
        .attr('y', 0)
        .attr('x',  d => xScale(d));

    const activiteiten = agenda.select('.activiteiten').selectAll('.activiteit').data(data, d => d.id);

    activiteiten.exit().remove();

    activiteiten
      .enter()
        .append('rect')
      .merge(activiteiten)
        .attr('class', d => 'activiteit ' + d.categorie + (showAdmin ? '' : ' onzichtbaar'))
        .attr('fill', d => d.categorie === 'niet-admin' ? colors['nonAdmin'] : colors[showProfession])
        .style('display', d => d.categorie !== 'admin' || showAdmin ? 'block' : 'none')
        //.attr('stroke-width', d => (d.categorie === 'admin' && d.seconds < 120) ? 0 : .75)
        //.attr('stroke', d => (d.categorie === 'admin' && d.seconds < 210) ? 'none' : '#fff')
        .attr('height', d => yScale(parseTime(d.eind)) - yScale(parseTime(d.start)) )
        .attr('width', d => d.categorie === 'admin' ? xScale.bandwidth()-10 : xScale.bandwidth())
        .attr('y', d => yScale(parseTime(d.start)) )
        .attr('x',  d => d.categorie === 'admin' ? xScale(d.weekdag)+5 : xScale(d.weekdag))
        .sort((a,b) => a.categorie < b.categorie)
        .on("mouseover", d => {
          const start = (d.start[6] === '0') ? d.start.slice(0,5) : d.start;
          const eind = (d.eind[6] === '0') ? d.eind.slice(0,5) : d.eind;
          const position = mouse(this.container);
          this.setState( {
            tooltip: {
              display: 'block',
              x: position[0] + 12,
              y: position[1],
              // x: xScale(d.weekdag) + margin.left + xScale.bandwidth(),
              // y: yScale(parseTime(d.start)) + 40 + 0.5*(yScale(parseTime(d.eind)) - yScale(parseTime(d.start))),
              time: start + '-' + eind + ' uur',
              text: d.wat
            }
          })
        });


    agenda.select('.dagen')
       .on('mouseleave', () => {
            this.setState( {
              tooltip: {
                display: 'none',
                x: 0,
                y: 0,
                text: ''
              }
            })
        });

    select(this.container)
      .on('mouseleave', () => {
          this.setState( {
            tooltip: {
              display: 'none',
              x: 0,
              y: 0,
              text: ''
            }
          })
        })


  }

  render() {
    const { width, height, margin } = this.state;
    const { display, x, y, time, text } = this.state.tooltip;
    const tooltipStyle = {
      display: display,
      position: 'absolute',
      left: x,
      top: y
    }

    return (
      <div className="Agenda" ref={container => this.container = container}>
        <svg
          id="weekagenda"
          width={width}
          height={height} >
          <g id="canvas" className="groep" transform={"translate(" + margin.left + "," + margin.top + ")"}>
            <g id="dagen" className="dagen" />
            <g id="activiteiten" className="activiteiten" />
            <g id="x-as" className="x as"></g>
            <g id="y-as" className="y as"></g>
          </g>
        </svg>
        <div className="tooltip" style={tooltipStyle}>
          <div>
            <p>{time}</p>
            <p>{text}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default Agenda;



// WEBPACK FOOTER //
// ./src/components/Agenda/Agenda.js